import { CookieNames, LocationSource } from '../constants';
import type { CookieClient, LocationData } from '../types';

const EXPECTED_COOKIE_COUNT = 5;

export default function getLocationFromCookies(
  cookies: CookieClient,
  ipAddress?: string
): LocationData | null {
  const location: LocationData = {
    state: cookies.get(CookieNames.State) ?? '',
    city: cookies.get(CookieNames.City) ?? '',
    zip: cookies.get(CookieNames.Zip) ?? '',
    ipAddress: cookies.get(CookieNames.IpAddress) ?? ipAddress ?? '',
    source: LocationSource.Cookies
  };

  const receivedCookieCount = Object.values(location).filter(Boolean).length;

  return receivedCookieCount === EXPECTED_COOKIE_COUNT ? location : null;
}
